import { render, staticRenderFns } from "./Participants.vue?vue&type=template&id=4f502159&scoped=true"
import script from "./Participants.vue?vue&type=script&lang=ts"
export * from "./Participants.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f502159",
  null
  
)

export default component.exports